import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Fanhui"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M2.49976 8H13.9329",
  stroke: "#2C364E",
  "stroke-width": "1.33333",
  "stroke-linecap": "square"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M5.93285 12L1.93286 8L5.93285 4",
  stroke: "#2C364E",
  "stroke-width": "1.33333",
  "stroke-linecap": "square"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var fanhui = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { fanhui as default };
